'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Select = function Select(props) {
  var hasError = false,
      error,
      value = props.value === undefined ? -1 : props.value;

  if (props.errors) {
    hasError = props.errors[props.name];
  }

  if (hasError) {
    error = props.errors[props.name].map(function (errorMsg) {
      return props.t(errorMsg);
    }).join(', ');
  }

  return /*#__PURE__*/_react.default.createElement("label", {
    className: "select ".concat(hasError ? 'error' : '', " ").concat(props.readOnly ? 'read-only' : '')
  }, props.label || (0, _utils.capitalizeFirstLetter)(props.name), /*#__PURE__*/_react.default.createElement("span", {
    className: "select__wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", {
    name: props.name,
    value: value,
    onChange: props.onChange
  }, /*#__PURE__*/_react.default.createElement("option", {
    disabled: true,
    value: "-1"
  }, props.placeholder), //TODO: Is allowAll really ever needed? If not, remove it. --> Yes is needed in the
  //project list (/projects) but if there is a better/simple solution we can do it.
  props.allowAll ? /*#__PURE__*/_react.default.createElement("option", {
    key: "".concat(props.name, "-all"),
    value: ''
  }, props.all) : '', props.list.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: item.id,
      value: item.id
    }, item.name);
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: "select__error"
  }, error));
};

Select.defaultProps = {
  readOnly: false,
  placeholder: '',
  allowAll: false,
  all: 'All'
};
Select.propTypes = {
  t: _propTypes.default.func.isRequired,
  placeholder: _propTypes.default.string,
  label: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  list: _propTypes.default.array.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  onChange: _propTypes.default.func,
  readOnly: _propTypes.default.bool,
  errors: _propTypes.default.any,
  allowAll: _propTypes.default.bool,
  all: _propTypes.default.string
};
var _default = Select;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/form-inputs/select.js
// module id = 511
// module chunks = 0